import React, { useEffect, useState, Component } from 'react';
import { CheckCircle2, XCircle, Clock, Star, FileText, Zap, ShieldCheck, Users, BookOpen, Gift, ChevronDown, AlertCircle, ArrowRight, MessageSquare, Calendar, Layers, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// --- Components ---
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 27,
    seconds: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex gap-2 font-mono text-xl md:text-2xl font-bold text-red-600" data-id="element-1">
      <div className="bg-red-50 px-2 py-1 rounded border border-red-100" data-id="element-2">
        {String(timeLeft.hours).padStart(2, '0')}h
      </div>
      <span data-id="element-3">:</span>
      <div className="bg-red-50 px-2 py-1 rounded border border-red-100" data-id="element-4">
        {String(timeLeft.minutes).padStart(2, '0')}m
      </div>
      <span data-id="element-5">:</span>
      <div className="bg-red-50 px-2 py-1 rounded border border-red-100" data-id="element-6">
        {String(timeLeft.seconds).padStart(2, '0')}s
      </div>
    </div>;
};
const FloatingNotification = () => {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const notifications = [{
    n: 'Valentina M.',
    l: 'Buenos Aires',
    t: 'hace 6 minutos',
    p: 'la Colección Completa 💛'
  }, {
    n: 'Lucía G.',
    l: 'Córdoba',
    t: 'hace 2 minutos',
    p: 'la Colección + Organizador ⭐'
  }, {
    n: 'Marcos P.',
    l: 'Rosario',
    t: 'hace 15 minutos',
    p: 'la Colección Completa 💛'
  }, {
    n: 'Elena S.',
    l: 'Mendoza',
    t: 'hace 8 minutos',
    p: 'la Colección + Organizador ⭐'
  }, {
    n: 'Javier R.',
    l: 'Salta',
    t: 'hace 22 minutos',
    p: 'la Colección Completa 💛'
  }, {
    n: 'Sofía B.',
    l: 'La Plata',
    t: 'hace 4 minutos',
    p: 'la Colección + Organizador ⭐'
  }, {
    n: 'Diego T.',
    l: 'Mar del Plata',
    t: 'hace 31 minutos',
    p: 'la Colección Completa 💛'
  }, {
    n: 'Martina L.',
    l: 'Neuquén',
    t: 'hace 12 minutos',
    p: 'la Colección + Organizador ⭐'
  }, {
    n: 'Andrés F.',
    l: 'Tucumán',
    t: 'hace 5 minutos',
    p: 'la Colección Completa 💛'
  }, {
    n: 'Paula V.',
    l: 'Posadas',
    t: 'hace 18 minutos',
    p: 'la Colección + Organizador ⭐'
  }, {
    n: 'Bruno D.',
    l: 'Santa Fe',
    t: 'hace 10 minutos',
    p: 'la Colección Completa 💛'
  }, {
    n: 'Camila O.',
    l: 'Bahía Blanca',
    t: 'hace 7 minutos',
    p: 'la Colección + Organizador ⭐'
  }, {
    n: 'Gabriel N.',
    l: 'San Juan',
    t: 'hace 25 minutos',
    p: 'la Colección + Organizador ⭐'
  }];
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => setVisible(true), 3000);
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setVisible(true);
      }, 1000); // Small delay for exit animation
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-7">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-6 left-6 z-50 bg-white shadow-2xl rounded-lg p-4 border border-slate-100 flex items-center gap-4 max-w-sm" data-id="element-8">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-[#10A37F]" data-id="element-9">
            <Check size={20} data-id="element-10" />
          </div>
          <div data-id="element-11">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-12">
              Compra verificada
            </p>
            <p className="text-sm text-slate-800" data-id="element-13">
              <span className="font-bold" data-id="element-14">{current.n}</span> de {current.l}
              <br data-id="element-15" />
              compró {current.p}
            </p>
            <p className="text-xs text-slate-400 mt-1" data-id="element-16">{current.t}</p>
          </div>
          <button onClick={() => setVisible(false)} className="text-slate-300 hover:text-slate-500" data-id="element-17">
            <XCircle size={16} data-id="element-18" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};
const SectionTitle = ({
  children,
  subtitle,
  light = false
}: {
  children: React.ReactNode;
  subtitle?: string;
  light?: boolean;
}) => <div className="text-center mb-8 md:mb-12" data-id="element-19">
    <h2 className={`text-3xl md:text-5xl font-bold mb-3 md:mb-4 ${light ? 'text-white' : 'text-slate-900'}`} data-id="element-20">
      {children}
    </h2>
    {subtitle && <p className={`text-base md:text-lg ${light ? 'text-slate-200' : 'text-slate-600'} max-w-2xl mx-auto font-sans px-4`} data-id="element-21">
        {subtitle}
      </p>}
  </div>;
const CTAButton = ({
  children,
  secondary = false,
  className = '',
  href = ''
}: {
  children: React.ReactNode;
  secondary?: boolean;
  className?: string;
  href?: string;
}) => {
  const content = <motion.button animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`${`
      w-full md:w-auto px-10 py-5 rounded-full font-bold text-lg transition-all transform hover:scale-105 active:scale-95 shadow-xl
      ${secondary ? 'bg-white text-slate-900 border-2 border-slate-200 hover:bg-slate-50' : 'bg-[#C4855A] text-white hover:bg-[#b0744d]'}
      ${className}
    `} text-[18px]`} data-id="element-22">
      {children}
    </motion.button>;
  if (href) {
    const isInternal = href.startsWith('#');
    return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className="w-full md:w-auto block" onClick={e => {
      if (isInternal) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }} data-id="element-23">
        {content}
      </a>;
  }
  return content;
};
// --- Main Page ---
export function LandingPage() {
  return <div className="min-h-screen font-sans" data-id="element-24">
      <FloatingNotification data-id="element-25" />

      {/* Top Bar - Hidden on small mobile to save space */}

      {/* Hero Section - Optimized for Mobile Above the Fold */}
      <header className="relative bg-[#10A37F] min-h-[100svh] flex flex-col text-white overflow-hidden" data-id="element-26">
        <div className="absolute top-0 left-0 w-full h-1 flex" data-id="element-27">
          <div className="flex-1 bg-white/20" data-id="element-28"></div>
          <div className="flex-1 bg-white/40" data-id="element-29"></div>
          <div className="flex-1 bg-white/20" data-id="element-30"></div>
        </div>

        <div className="container mx-auto px-4 flex-grow flex flex-col justify-center py-4 md:py-16 relative z-10" data-id="element-31">
          <div className="max-w-4xl mx-auto text-center flex flex-col h-full" data-id="element-32">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="inline-flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full text-white text-[10px] md:text-sm font-bold mb-3 md:mb-8 backdrop-blur-sm self-center" data-id="element-33">
              🌿 EL DUELO DEL DIAGNÓSTICO™
            </motion.div>

            <h1 className="text-3xl md:text-7xl font-bold leading-tight mb-3 md:mb-8" data-id="element-34">
              Todo lo que necesitás para <br className="hidden md:block" data-id="element-35" />
              atravesar el diagnóstico. <br data-id="element-36" />
              <span className="text-[#F5EFE6]" data-id="element-37">Listo. Desde hoy.</span>
            </h1>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.8
          }} className="relative max-w-[240px] md:max-w-3xl mx-auto mb-4 md:mb-12 group" data-id="element-38">
              <div className="absolute inset-0 bg-[#10A37F] blur-3xl opacity-20 group-hover:opacity-40 transition-opacity duration-700" data-id="element-39"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3q8DkYYq9EATFiJaXfoDh6/el-duelo-diagnostico-landing-1200.webp" alt="El Duelo del Diagnóstico Mockup" className="relative z-10 w-full h-auto rounded-xl shadow-xl" style={{
              maskImage: 'radial-gradient(circle, black 60%, transparent 95%)',
              WebkitMaskImage: 'radial-gradient(circle, black 60%, transparent 95%)'
            }} data-id="element-40" />
            </motion.div>

            <p className="text-sm md:text-2xl text-slate-100 mb-4 md:mb-10 max-w-2xl mx-auto leading-snug md:leading-relaxed px-4" data-id="element-41">
              La guía N°1 de acompañamiento emocional en Argentina.{' '}
              <span className="font-bold text-white" data-id="element-42">
                Contención + herramientas + hoja de ruta.
              </span>
            </p>

            <div className="flex flex-col items-center gap-3 md:gap-6 mb-4 md:mb-12" data-id="element-43">
              <CTAButton href="https://checkout2.guiadigital360.online/cart/44366208368733:1" className="uppercase tracking-wide px-8 py-3 md:px-12 md:py-5 text-sm md:text-lg" data-id="element-44">
                → QUIERO MI ACOMPAÑAMIENTO AHORA
              </CTAButton>

              <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-slate-100 font-medium text-[10px] md:text-sm" data-id="element-45">
                <div className="flex items-center gap-1" data-id="element-46">
                  <FileText size={12} className="md:w-[18px] md:h-[18px]" data-id="element-47" />{' '}
                  100% PDF
                </div>
                <div className="flex items-center gap-1" data-id="element-48">
                  <Zap size={12} className="md:w-[18px] md:h-[18px]" data-id="element-49" /> Acceso
                  en 5 min
                </div>
                <div className="flex items-center gap-1" data-id="element-50">
                  <ShieldCheck size={12} className="md:w-[18px] md:h-[18px]" data-id="element-51" />{' '}
                  Garantía 7 días
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-3 md:p-6 shadow-xl inline-block self-center" data-id="element-52">
              <p className="text-[#F5EFE6] font-bold uppercase tracking-widest text-[8px] md:text-sm mb-1 md:mb-3" data-id="element-53">
                ⏰ CIERRA EN:
              </p>
              <CountdownTimer data-id="element-54" />
            </div>
          </div>
        </div>
      </header>

      {/* Stats Section */}
      <section className="py-8 md:py-12 bg-white border-b border-slate-100" data-id="element-55">
        <div className="container mx-auto px-4" data-id="element-56">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto text-center" data-id="element-57">
            {[{
            label: 'familias acompañ.',
            value: '+300'
          }, {
            label: 'tomos y bonos',
            value: '8'
          }, {
            label: 'páginas listas',
            value: '360+'
          }, {
            label: 'calificación',
            value: '4.9/5',
            stars: true
          }].map((stat, i) => <div key={i} data-id="element-58">
                <p className="text-3xl md:text-4xl font-bold text-[#10A37F] mb-1" data-id="element-59">
                  {stat.value}
                </p>
                {stat.stars && <div className="flex justify-center text-yellow-500 mb-1" data-id="element-60">
                    <Star size={14} fill="currentColor" data-id="element-61" />
                    <Star size={14} fill="currentColor" data-id="element-62" />
                    <Star size={14} fill="currentColor" data-id="element-63" />
                    <Star size={14} fill="currentColor" data-id="element-64" />
                    <Star size={14} fill="currentColor" data-id="element-65" />
                  </div>}
                <p className="text-xs uppercase tracking-widest text-slate-500 font-bold" data-id="element-66">
                  {stat.label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonials 1 */}
      <section className="py-12 md:py-24 bg-[#F5EFE6]" data-id="element-67">
        <div className="container mx-auto px-4" data-id="element-68">
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-69">
            {[{
            n: 'María R.',
            l: 'Buenos Aires',
            q: 'Llegué destrozada después del diagnóstico de mi hijo. Este material me dio palabras para lo que sentía y pasos para no paralizarme.',
            i: 'MR'
          }, {
            n: 'Carla P.',
            l: 'Córdoba',
            q: 'El Tomo 1 lo leí llorando. Por primera vez alguien describía exactamente lo que viví ese día en el consultorio.',
            i: 'CP'
          }, {
            n: 'Jorge M.',
            l: 'Rosario',
            q: 'El Kit SOS 72H me lo mandaron a las 11pm. Lo abrí en el celular y me ayudó a sobrevivir esa noche. Vale cada peso.',
            i: 'JM'
          }].map((test, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-70">
                <div className="flex gap-1 mb-4 text-yellow-500" data-id="element-71">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" />)}
                </div>
                <p className="text-slate-700 italic mb-6 leading-relaxed" data-id="element-73">
                  "{test.q}"
                </p>
                <div className="flex items-center gap-4" data-id="element-74">
                  <div className="w-10 h-10 bg-[#10A37F] rounded-full flex items-center justify-center font-bold text-white" data-id="element-75">
                    {test.i}
                  </div>
                  <div data-id="element-76">
                    <p className="font-bold text-slate-900" data-id="element-77">{test.n}</p>
                    <p className="text-xs text-slate-500" data-id="element-78">{test.l}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-12 md:py-24 bg-white" data-id="element-79">
        <div className="container mx-auto px-4" data-id="element-80">
          <SectionTitle subtitle="Recibiste un diagnóstico. Tuyo. O de alguien que amás. Y nadie te dijo lo que venía después." data-id="element-81">
            ¿Cuántas noches más vas a quedarte sin poder dormir, sin saber qué
            hacer?
          </SectionTitle>

          <div className="max-w-3xl mx-auto text-center mb-8 md:mb-16" data-id="element-82">
            <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-83">
              Nadie te preparó para ese silencio en el auto al salir del
              consultorio. Para esa sensación de que el piso desaparece debajo
              tuyo. Para no saber qué decirle a la familia. Para googlear a las
              2am y encontrar solo los peores casos posibles.
            </p>
            <p className="text-xl font-bold text-[#C4855A]" data-id="element-84">
              No es falta de fortaleza. Es falta de acompañamiento.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-85">
            {['Noches sin dormir buscando información que solo da más miedo', 'Sin saber qué decirle a la familia, a la escuela, al trabajo', 'Cargando la culpa de creer que algo hiciste mal', 'Fingiendo estar bien mientras por adentro te derrumbás', 'El sistema médico que te da un papel y no te dice cómo vivir', 'Sintiéndote solo/a aunque estés rodeado/a de gente', 'Cada mañana con ese peso encima antes de abrir los ojos'].map((item, i) => <div key={i} className="bg-slate-50 p-4 rounded-lg flex gap-3 items-start" data-id="element-86">
                <XCircle className="text-red-400 shrink-0 mt-1" size={20} data-id="element-87" />
                <p className="text-slate-700 font-medium" data-id="element-88">{item}</p>
              </div>)}
          </div>

          <div className="mt-8 md:mt-16 text-center" data-id="element-89">
            <p className="text-2xl font-bold text-slate-900 mb-4 italic" data-id="element-90">
              ¿Y si esta fuera la última noche que lo atravesás completamente
              solo/a?
            </p>
            <div className="w-24 h-1 bg-[#10A37F] mx-auto rounded-full" data-id="element-91"></div>
          </div>
        </div>
      </section>

      {/* Product Hero */}
      <section className="py-12 md:py-24 bg-[#10A37F] text-white" data-id="element-92">
        <div className="container mx-auto px-4 text-center" data-id="element-93">
          <SectionTitle light subtitle="5 Tomos + 3 Bonos · 360+ páginas · Todo lo que necesitás para entender, aceptar y actuar." data-id="element-94">
            💛 EL DUELO DEL DIAGNÓSTICO™ COLECCIÓN COMPLETA
          </SectionTitle>

          <div className="max-w-4xl mx-auto mb-12 relative" data-id="element-95">
            {/* Mockup Placeholder */}
            <div className="aspect-video bg-white/10 rounded-3xl border-2 border-white/20 flex items-center justify-center backdrop-blur-sm shadow-2xl" data-id="element-96">
              <div className="text-center" data-id="element-97">
                <BookOpen size={80} className="mx-auto mb-4 text-[#F5EFE6]" data-id="element-98" />
                <p className="text-2xl font-bold" data-id="element-99">MOCKUP COLECCIÓN COMPLETA</p>
                <p className="text-slate-200" data-id="element-100">8 Tomos y Bonos Digitales</p>
              </div>
            </div>
          </div>

          <p className="text-2xl font-bold italic text-[#F5EFE6]" data-id="element-101">
            "Para entender, aceptar y actuar después del diagnóstico."
          </p>
          <p className="text-lg mt-4 text-slate-100" data-id="element-102">
            Escrito por quien lo vivió. 100% adaptado a la realidad argentina.
          </p>
        </div>
      </section>

      {/* The 5 Tomos */}
      <section className="py-12 md:py-24 bg-white" data-id="element-103">
        <div className="container mx-auto px-4" data-id="element-104">
          <SectionTitle subtitle="Cada tomo incluye ejercicios prácticos, prompts de escritura y contención profunda." data-id="element-105">
            📚 5 TOMOS COMPLETOS
          </SectionTitle>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-106">
            {[{
            t: '🌿 TOMO I — EL IMPACTO',
            d: 'Para las primeras horas y días. Entender el shock, validar el dolor y sobrevivir el primer impacto sin ahogarse en él.',
            f: ['Las etapas del duelo', 'El permiso para sentir', 'Lo que nadie te dice', 'Carta para cuando no podés más']
          }, {
            t: '🌿 TOMO II — DESARMANDO CREENCIAS',
            d: 'Los 10 mitos más dañinos y la realidad que nadie te contó. Separar la etiqueta médica de quien realmente sos.',
            f: ['Mitos vs Realidad', 'Lo que el sistema no dijo', 'La culpa que cargás', 'Reescribir la historia']
          }, {
            t: '🌿 TOMO III — LA MIRADA AJENA',
            d: 'Cómo comunicar el diagnóstico, manejar el juicio externo y proteger tu paz sin aislarte.',
            f: ['Guiones listos', 'Límites como acto de amor', 'La familia que no entiende', 'Elegir tu tribu']
          }, {
            t: '🌿 TOMO IV — LO QUE SIENTO HOY',
            d: 'Bitácora guiada para procesar el duelo momento a momento con prompts diarios.',
            f: ['Prompts de emoción', 'Registro corporal', 'Vaciado emocional', 'Cierre reflexivo']
          }, {
            t: '🌿 TOMO V — HOJA DE RUTA',
            d: 'Entender y actuar: organizarte sin perder la paz. Guía CUD y obras sociales argentina.',
            f: ['Guía CUD y Obras Sociales', 'Tu equipo de salud', 'Organizar tiempo y energía', 'Plan mensual flexible']
          }].map((tomo, i) => <div key={i} className="p-8 rounded-2xl border border-slate-100 bg-slate-50 hover:bg-white hover:shadow-xl transition-all" data-id="element-107">
                <h3 className="text-xl font-bold mb-4 text-[#10A37F]" data-id="element-108">
                  {tomo.t}
                </h3>
                <p className="text-slate-600 mb-6 text-sm leading-relaxed" data-id="element-109">
                  {tomo.d}
                </p>
                <ul className="space-y-2" data-id="element-110">
                  {tomo.f.map((feature, j) => <li key={j} className="flex items-center gap-2 text-xs font-bold text-slate-500" data-id="element-111">
                      <CheckCircle2 size={14} className="text-[#10A37F]" data-id="element-112" />{' '}
                      {feature}
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-12 md:py-24 bg-[#F5EFE6]" data-id="element-113">
        <div className="container mx-auto px-4" data-id="element-114">
          <SectionTitle subtitle="Valor total bonos: $25.000 → GRATIS con tu colección" data-id="element-115">
            🎁 3 BONOS ESTRATÉGICOS
          </SectionTitle>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-116">
            {[{
            n: '01',
            t: 'KIT SOS 72H',
            d: 'Primeros Auxilios Emocionales. Protocolo 5 y 15 min + Checklists Día 1, 2 y 3.',
            v: '$8.000'
          }, {
            n: '02',
            t: 'ABRAZO GUIADO',
            d: '12 cartas para leer en los días más difíciles. Escritas por alguien que lo vivió.',
            v: '$9.000'
          }, {
            n: '03',
            t: 'PLAN DE CONTENCIÓN',
            d: 'Para quien acompaña pero no sabe cómo. Frases que ayudan vs las que lastiman.',
            v: '$8.000'
          }].map((bono, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 relative overflow-hidden" data-id="element-117">
                <div className="absolute top-0 right-0 bg-[#C4855A] text-white text-[10px] font-bold px-4 py-1 rounded-bl-lg uppercase" data-id="element-118">
                  Gratis
                </div>
                <span className="text-[#C4855A] font-bold text-sm mb-2 block" data-id="element-119">
                  BONO {bono.n}
                </span>
                <h4 className="text-xl font-bold mb-3" data-id="element-120">{bono.t}</h4>
                <p className="text-slate-600 text-sm mb-6 leading-relaxed" data-id="element-121">
                  {bono.d}
                </p>
                <p className="text-sm line-through text-slate-400" data-id="element-122">{bono.v}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-8 md:py-24 bg-[#10A37F] text-white min-h-[100svh] flex flex-col justify-center" id="pricing" data-id="element-123">
        <div className="container mx-auto px-4" data-id="element-124">
          <div className="text-center mb-6 md:mb-12" data-id="element-125">
            <h2 className="text-2xl md:text-5xl font-bold mb-2" data-id="element-126">
              ELEGÍ TU COLECCIÓN
            </h2>
            <p className="text-xs md:text-lg text-[#F5EFE6] font-bold uppercase tracking-widest" data-id="element-127">
              ⏰ PRECIO DE LANZAMIENTO CIERRA EN:
            </p>
          </div>

          <div className="flex justify-center mb-6 md:mb-12 scale-75 md:scale-100" data-id="element-128">
            <CountdownTimer data-id="element-129" />
          </div>

          <div className="grid md:grid-cols-2 gap-4 md:gap-8 max-w-5xl mx-auto" data-id="element-130">
            {/* Tier 1 */}
            <div className="bg-white rounded-2xl p-5 md:p-10 text-slate-900 shadow-2xl flex flex-col" data-id="element-131">
              <div className="mb-4 md:mb-8" data-id="element-132">
                <h3 className="text-lg md:text-2xl font-bold" data-id="element-133">
                  💛 COLECCIÓN COMPLETA
                </h3>
                <p className="text-slate-500 text-[10px] md:text-sm" data-id="element-134">
                  5 Tomos + 3 Bonos
                </p>
              </div>

              <div className="mb-4 md:mb-8" data-id="element-135">
                <p className="text-slate-400 line-through text-sm md:text-lg" data-id="element-136">
                  $47.000
                </p>
                <p className="text-3xl md:text-5xl font-bold text-slate-900" data-id="element-137">
                  $19.990{' '}
                  <span className="text-sm md:text-xl font-medium" data-id="element-138">ARS</span>
                </p>
              </div>

              <ul className="hidden md:block space-y-4 mb-10 flex-grow" data-id="element-139">
                {['5 Tomos de acompañamiento', 'Kit SOS 72H', 'Abrazo Guiado', 'Plan de Contención', 'Acceso inmediato PDF'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-600 text-sm" data-id="element-140">
                    <CheckCircle2 size={18} className="text-[#10A37F] shrink-0" data-id="element-141" />
                    <span data-id="element-142">{item}</span>
                  </li>)}
              </ul>

              <CTAButton href="https://checkout2.guiadigital360.online/cart/44366208368733:1" className="w-full py-3 md:py-5 text-sm md:text-lg" data-id="element-143">
                → QUIERO MI COLECCIÓN
              </CTAButton>
            </div>

            {/* Tier 2 */}
            <div className="bg-white rounded-2xl p-5 md:p-10 text-slate-900 shadow-2xl flex flex-col border-2 md:border-4 border-[#C4855A] relative" data-id="element-144">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C4855A] text-white font-bold px-4 py-1 rounded-full text-[8px] md:text-xs uppercase tracking-widest" data-id="element-145">
                MÁS COMPLETO ⭐
              </div>
              <div className="mb-4 md:mb-8" data-id="element-146">
                <h3 className="text-lg md:text-2xl font-bold" data-id="element-147">
                  💛 COLECCIÓN + ORGANIZADOR VITAL
                </h3>
                <p className="text-slate-500 text-[10px] md:text-sm" data-id="element-148">
                  5 Tomos + 3 Bonos + Organizador 360
                </p>
              </div>

              <div className="mb-4 md:mb-8" data-id="element-149">
                <p className="text-slate-400 line-through text-sm md:text-lg" data-id="element-150">
                  $69.000
                </p>
                <p className="text-3xl md:text-5xl font-bold text-slate-900" data-id="element-151">
                  $24.990{' '}
                  <span className="text-sm md:text-xl font-medium" data-id="element-152">ARS</span>
                </p>
              </div>

              <ul className="hidden md:block space-y-4 mb-10 flex-grow" data-id="element-153">
                <li className="flex items-start gap-3 text-slate-900 font-bold text-sm" data-id="element-154">
                  <CheckCircle2 size={18} className="text-[#10A37F] shrink-0" data-id="element-155" />
                  <span data-id="element-156">TODO LO DE LA COLECCIÓN</span>
                </li>
                {['Organizador Vital Post-Diagnóstico', 'Tracker de medicación semanal', 'Control de trámites y gastos', 'Planner semanal + fichas emocionales'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-600 text-sm font-bold" data-id="element-157">
                    <Star size={18} className="text-[#C4855A] shrink-0 fill-[#C4855A]" data-id="element-158" />
                    <span data-id="element-159">{item}</span>
                  </li>)}
              </ul>

              <CTAButton href="https://checkout2.guiadigital360.online/cart/44367122530397:1" className="w-full py-3 md:py-5 text-sm md:text-lg" data-id="element-160">
                → QUIERO LA COLECCION COMPLETA
              </CTAButton>
            </div>
          </div>

          <div className="mt-6 md:mt-12 text-center" data-id="element-161">
            <p className="text-[#F5EFE6] font-bold text-[10px] md:text-base" data-id="element-162">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-12 md:py-24 bg-white" data-id="element-163">
        <div className="container mx-auto px-4" data-id="element-164">
          <SectionTitle subtitle="La próxima noche difícil puede ser diferente." data-id="element-165">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </SectionTitle>

          <div className="max-w-4xl mx-auto overflow-hidden rounded-2xl border border-slate-200 shadow-xl" data-id="element-166">
            <table className="w-full text-left border-collapse" data-id="element-167">
              <thead data-id="element-168">
                <tr className="bg-slate-50 border-b border-slate-200" data-id="element-169">
                  <th className="p-4 md:p-6 font-bold text-slate-900" data-id="element-170">
                    SITUACIÓN
                  </th>
                  <th className="p-4 md:p-6 font-bold text-red-500" data-id="element-171">
                    ❌ SIN COLECCIÓN
                  </th>
                  <th className="p-4 md:p-6 font-bold text-[#10A37F]" data-id="element-172">
                    ✅ CON COLECCIÓN
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-173">
                {[{
                s: 'Noche del diagnóstico',
                no: 'Parálisis total',
                yes: 'Kit SOS 72H listo en 5 min'
              }, {
                s: 'No entender al médico',
                no: 'Meses de confusión y miedo',
                yes: 'Tomo II + V: todo claro'
              }, {
                s: 'Hablar con la familia',
                no: 'Silencio o peleas inevitables',
                yes: 'Tomo III: guiones listos'
              }, {
                s: 'Días en que no podés más',
                no: 'Colapso emocional',
                yes: 'Abrazo Guiado: carta exacta'
              }, {
                s: 'Tu pareja no sabe ayudar',
                no: 'Conflictos y distancia',
                yes: 'Plan de Contención'
              }, {
                s: 'Trámites CUD / Obras Soc.',
                no: 'Meses sin cobertura',
                yes: 'Tomo V: guía paso a paso'
              }].map((row, i) => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-174">
                    <td className="p-4 md:p-6 text-sm font-bold text-slate-800" data-id="element-175">
                      {row.s}
                    </td>
                    <td className="p-4 md:p-6 text-sm text-slate-500 italic" data-id="element-176">
                      {row.no}
                    </td>
                    <td className="p-4 md:p-6 text-sm font-bold text-slate-900" data-id="element-177">
                      {row.yes}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="text-center mt-12 text-2xl font-bold text-[#10A37F]" data-id="element-178">
            "No estás solo/a en esto." 💛
          </p>
        </div>
      </section>

      {/* Testimonials 2 */}
      <section className="py-12 md:py-24 bg-[#F5EFE6]" data-id="element-179">
        <div className="container mx-auto px-4" data-id="element-180">
          <SectionTitle subtitle="Más personas que ya lo tienen" data-id="element-181">
            ❤️ TESTIMONIOS
          </SectionTitle>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-182">
            {[{
            n: 'Silvana R.',
            l: 'Mendoza · Mamá de niño con TEA',
            q: 'El Tomo III me enseñó a hablarle a la maestra sin derrumbarme. Antes salía llorando de cada reunión.',
            i: 'SR'
          }, {
            n: 'Federico M.',
            l: 'Buenos Aires · Diagnóstico artritis',
            q: "El ejercicio de identidad del Tomo II me cambió la forma de presentarme. Dejé de decir 'soy artrítico'.",
            i: 'FM'
          }, {
            n: 'Laura C.',
            l: 'La Plata · Mamá de nena con TDAH',
            q: 'El Plan de Contención se lo di a mi marido y a mi mamá. Por primera vez todos saben cómo ayudar.',
            i: 'LC'
          }, {
            n: 'Pablo A.',
            l: 'Rosario · Esclerosis múltiple',
            q: 'El Tomo V me ahorró meses de burocracia. El CUD lo tramité en dos semanas con la guía.',
            i: 'PA'
          }].map((test, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex gap-6 items-start" data-id="element-183">
                <div className="w-12 h-12 bg-[#10A37F] rounded-full shrink-0 flex items-center justify-center font-bold text-white text-lg" data-id="element-184">
                  {test.i}
                </div>
                <div data-id="element-185">
                  <div className="flex gap-1 mb-2 text-yellow-500" data-id="element-186">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-187" />)}
                  </div>
                  <p className="text-slate-700 italic mb-4" data-id="element-188">"{test.q}"</p>
                  <p className="font-bold text-slate-900 text-sm" data-id="element-189">{test.n}</p>
                  <p className="text-xs text-slate-500" data-id="element-190">{test.l}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why choose the complete option? */}
      <section className="py-12 md:py-24 bg-[#F5EFE6]" data-id="element-191">
        <div className="container mx-auto px-4" data-id="element-192">
          <SectionTitle subtitle="No es un libro más para leer. Es una herramienta para usar." data-id="element-193">
            ⭐ ¿POR QUÉ ELEGIR LA OPCIÓN COMPLETA?
          </SectionTitle>

          <div className="max-w-4xl mx-auto" data-id="element-194">
            <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-slate-100 mb-12" data-id="element-195">
              <div className="grid md:grid-cols-2 gap-12" data-id="element-196">
                <div className="space-y-6" data-id="element-197">
                  <p className="text-lg text-slate-700 leading-relaxed" data-id="element-198">
                    Los 5 Tomos te dan las herramientas para entender, aceptar y
                    procesar el diagnóstico.
                  </p>
                  <p className="text-lg text-slate-700 leading-relaxed" data-id="element-199">
                    Pero el día a día no para mientras procesás. Los turnos
                    siguen llegando. Los remedios hay que tomarlos. Las recetas
                    vencen. Los gastos se acumulan. Los trámites no esperan.
                  </p>
                  <p className="text-lg text-slate-700 leading-relaxed" data-id="element-200">
                    Y en el medio de todo eso, también necesitás un espacio para
                    preguntarte cómo estás vos.
                  </p>
                  <div className="p-6 bg-[#10A37F]/5 rounded-2xl border border-[#10A37F]/10" data-id="element-201">
                    <p className="text-xl font-bold text-[#10A37F] mb-2" data-id="element-202">
                      ORGANIZADOR VITAL POST-DIAGNÓSTICO
                    </p>
                    <p className="text-slate-600" data-id="element-203">
                      Todos los días. Todas las semanas. Durante todo el año.
                    </p>
                  </div>
                </div>

                <div className="space-y-6" data-id="element-204">
                  <h4 className="font-bold text-slate-900 uppercase tracking-widest text-sm" data-id="element-205">
                    LO QUE RESUELVE:
                  </h4>
                  <div className="grid grid-cols-1 gap-4" data-id="element-206">
                    {[{
                    t: '💊 TRACKER DE MEDICACIÓN',
                    d: 'Grilla semanal visual. Mañana · Tarde · Noche. Marcá si la tomaste. Nunca más olvidar un remedio.'
                  }, {
                    t: '🗓️ PLANNER SEMANAL',
                    d: 'Turnos + tareas + descanso en una sola vista de 7 días.'
                  }, {
                    t: '📋 CONTROL DE TRÁMITES',
                    d: 'Semáforo rojo/amarillo/verde. CUD · Prepaga · Reintegros. Seguimiento de cada trámite.'
                  }, {
                    t: '💰 REGISTRO DE GASTOS',
                    d: 'Todo lo que gastás por mes. Qué cubre la prepaga. Cuánto sale de tu bolsillo.'
                  }, {
                    t: '🏥 FICHAS DE CONSULTA',
                    d: 'Una por cada turno médico. Preguntas + respuestas + próximos pasos.'
                  }, {
                    t: '🌸 ESPACIO DE RESPIRO',
                    d: 'Fichas diarias: "Hoy disfruté de...", "Hoy me dolió...", "Mañana necesito..."'
                  }].map((item, i) => <div key={i} className="flex gap-3" data-id="element-207">
                        <div className="shrink-0 mt-1" data-id="element-208">
                          <CheckCircle2 size={16} className="text-[#10A37F]" data-id="element-209" />
                        </div>
                        <div data-id="element-210">
                          <p className="font-bold text-slate-900 text-sm" data-id="element-211">
                            {item.t}
                          </p>
                          <p className="text-xs text-slate-500" data-id="element-212">{item.d}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-sm font-bold text-[#C4855A] bg-[#C4855A]/5 p-3 rounded-lg border border-[#C4855A]/10" data-id="element-213">
                    40 PÁGINAS IMPRIMIBLES. Imprimí las que más usás. Reimprimí
                    las reutilizables cada semana. Sin límite.
                  </p>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-214">
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-215">
                <p className="font-bold text-slate-900 mb-6" data-id="element-216">
                  COLECCIÓN BASE $19.990:
                </p>
                <ul className="space-y-3" data-id="element-217">
                  {['5 Tomos completos', '3 Bonos estratégicos', 'Organizador Vital', 'Tracker medicación', 'Control de trámites', 'Planner semanal', 'Fichas de respiro'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm" data-id="element-218">
                      {i < 2 ? <Check size={16} className="text-[#10A37F]" data-id="element-219" /> : <XCircle size={16} className="text-red-400" data-id="element-220" />}
                      <span className={i < 2 ? 'text-slate-700' : 'text-slate-400'} data-id="element-221">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
              <div className="bg-white p-8 rounded-2xl border-2 border-[#C4855A] shadow-lg relative overflow-hidden" data-id="element-222">
                <div className="absolute top-0 right-0 bg-[#C4855A] text-white text-[10px] font-bold px-4 py-1 rounded-bl-lg uppercase" data-id="element-223">
                  RECOMENDADO
                </div>
                <p className="font-bold text-slate-900 mb-6" data-id="element-224">
                  COLECCIÓN + ORGANIZADOR $24.990:
                </p>
                <ul className="space-y-3" data-id="element-225">
                  {['5 Tomos completos', '3 Bonos estratégicos', 'Organizador Vital', 'Tracker medicación', 'Control de trámites', 'Planner semanal', 'Fichas de respiro'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm" data-id="element-226">
                      <Check size={16} className="text-[#10A37F]" data-id="element-227" />
                      <span className="text-slate-700 font-bold" data-id="element-228">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="text-center space-y-6" data-id="element-229">
              <p className="text-lg text-slate-600" data-id="element-230">
                La diferencia es de $5.000. El Organizador Vital por separado
                vale $15.000. <br data-id="element-231" />
                <span className="font-bold text-slate-900" data-id="element-232">
                  Hoy lo llevás por la mitad solo porque lo sumás a la
                  colección.
                </span>
              </p>
              <div className="flex flex-col md:flex-row justify-center gap-4" data-id="element-233">
                <CTAButton href="https://checkout2.guiadigital360.online/cart/44366208368733:1" secondary className="text-sm md:text-base px-6 py-4" data-id="element-234">
                  💛 QUIERO SOLO LA COLECCIÓN — $19.990
                </CTAButton>
                <CTAButton href="https://checkout2.guiadigital360.online/cart/44367122530397:1" className="text-sm md:text-base px-6 py-4" data-id="element-235">
                  ⭐ QUIERO LA COLECCIÓN + ORGANIZADOR — $24.990
                </CTAButton>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-12 md:py-24 bg-white" data-id="element-236">
        <div className="container mx-auto px-4 text-center" data-id="element-237">
          <div className="max-w-3xl mx-auto bg-[#F5EFE6] p-8 md:p-12 rounded-3xl border-2 border-[#10A37F]/20" data-id="element-238">
            <ShieldCheck size={64} className="text-[#10A37F] mx-auto mb-6" data-id="element-239" />
            <h2 className="text-3xl font-bold mb-4" data-id="element-240">
              GARANTÍA 7 DÍAS SIN PREGUNTAS
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-241">
              Abrís los tomos. Los leés. Los usás. Si en 7 días no es lo que
              esperabas:
              <span className="font-bold text-slate-900" data-id="element-242">
                {' '}
                DEVOLUCIÓN DEL 100% sin formularios · sin drama · sin vueltas.
              </span>
            </p>
            <p className="text-sm text-slate-400 uppercase tracking-widest font-bold" data-id="element-243">
              Tasa de devoluciones: menos del 1%
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 md:py-24 bg-[#F5EFE6]" data-id="element-244">
        <div className="container mx-auto px-4" data-id="element-245">
          <SectionTitle subtitle="Despejá tus dudas y empezá hoy mismo." data-id="element-246">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </SectionTitle>
          <div className="max-w-3xl mx-auto space-y-4" data-id="element-247">
            {[{
            q: '¿Para quién es esta colección?',
            a: 'Para padres de niños recién diagnosticados y adultos con diagnóstico de salud mental, discapacidad o enfermedad crónica. También para quienes los acompañan.'
          }, {
            q: '¿Cómo recibo el material?',
            a: '100% digital. PDF de alta resolución. Acceso inmediato tras el pago. Celular, tablet o computadora. También podés imprimirlo.'
          }, {
            q: '¿Qué lo diferencia de otros libros?',
            a: 'Está escrito por alguien que vivió el diagnóstico, no por un académico. Habla del duelo específico del diagnóstico y está 100% adaptado a Argentina (CUD, obras sociales, leyes vigentes).'
          }, {
            q: '¿Sirve aunque haga tiempo que recibí el diagnóstico?',
            a: 'Sí. El duelo del diagnóstico no tiene fecha de vencimiento. Podés empezar en cualquier momento para procesar lo que quedó pendiente.'
          }, {
            q: '¿Tiene garantía real?',
            a: 'Sí. 7 días. Devolución del 100%. Sin preguntas. Sin formularios.'
          }].map((faq, i) => <details key={i} className="group bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-248">
                <summary className="flex items-center justify-between p-6 cursor-pointer font-bold text-slate-900 list-none" data-id="element-249">
                  {faq.q}
                  <ChevronDown size={20} className="text-slate-400 group-open:rotate-180 transition-transform" data-id="element-250" />
                </summary>
                <div className="px-6 pb-6 text-slate-600 leading-relaxed text-sm" data-id="element-251">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-12 md:py-24 bg-[#10A37F] text-white text-center" data-id="element-252">
        <div className="container mx-auto px-4" data-id="element-253">
          <SectionTitle light subtitle="La próxima noche difícil puede ser diferente." data-id="element-254">
            ⏰ EL PRECIO CIERRA EN:
          </SectionTitle>
          <div className="flex justify-center mb-8 md:mb-12" data-id="element-255">
            <CountdownTimer data-id="element-256" />
          </div>

          <div className="max-w-4xl mx-auto space-y-8" data-id="element-257">
            <div className="bg-white/10 p-8 rounded-2xl border border-white/20 backdrop-blur-sm" data-id="element-258">
              <h3 className="text-2xl font-bold mb-4" data-id="element-259">
                💛 COLECCIÓN COMPLETA EL DUELO DEL DIAGNÓSTICO™
              </h3>
              <p className="text-sm text-slate-200 mb-4" data-id="element-260">
                5 Tomos + 3 Bonos · 360+ páginas
              </p>
              <p className="text-3xl font-bold mb-6" data-id="element-261">
                <span className="line-through text-slate-400 text-xl mr-4" data-id="element-262">
                  $47.000
                </span>{' '}
                $19.990 ARS
              </p>
              <CTAButton href="https://checkout2.guiadigital360.online/cart/44366208368733:1" className="w-full md:w-auto" data-id="element-263">
                → QUIERO MI COLECCIÓN AHORA
              </CTAButton>
            </div>

            <div className="bg-white/10 p-8 rounded-2xl border-4 border-[#C4855A] backdrop-blur-sm relative" data-id="element-264">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#C4855A] text-white font-bold px-6 py-1 rounded-full text-xs uppercase tracking-widest" data-id="element-265">
                ⭐ MÁS COMPLETO
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-266">
                💛 COLECCIÓN + ORGANIZADOR VITAL
              </h3>
              <p className="text-sm text-slate-200 mb-4" data-id="element-267">
                5 Tomos + 3 Bonos + Organizador 360: Organizador Vital
              </p>
              <p className="text-3xl font-bold mb-6" data-id="element-268">
                <span className="line-through text-slate-400 text-xl mr-4" data-id="element-269">
                  $69.000
                </span>{' '}
                $24.990 ARS
              </p>
              <ul className="grid md:grid-cols-2 gap-3 text-left max-w-2xl mx-auto mb-8 text-sm" data-id="element-270">
                {['TODO LO DE LA COLECCIÓN', '40 páginas de planillas imprimibles', 'Tracker de medicación semanal', 'Planner semanal + control de trámites', 'Fichas emocionales de respiro diario', 'Registro de gastos mensual'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-271">
                    <Star size={14} className="text-[#C4855A] fill-[#C4855A] shrink-0" data-id="element-272" />
                    <span className="font-bold" data-id="element-273">{item}</span>
                  </li>)}
              </ul>
              <CTAButton href="https://checkout2.guiadigital360.online/cart/44367122530397:1" className="w-full md:w-auto" data-id="element-274">
                → QUIERO ESTA OPCIÓN
              </CTAButton>
            </div>
          </div>

          <div className="mt-12 flex flex-wrap justify-center gap-8 text-slate-100 text-sm font-bold" data-id="element-275">
            <span data-id="element-276">🔒 Pago 100% seguro</span>
            <span data-id="element-277">⚡ Acceso en 5 minutos</span>
            <span data-id="element-278">🛡️ Garantía 7 días</span>
            <span data-id="element-279">💳 Mercado Pago · Tarjeta · Transferencia</span>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 bg-[#2C2420] text-slate-400 border-t border-white/5" data-id="element-280">
        <div className="container mx-auto px-4 text-center" data-id="element-281">
          <p className="font-bold text-white text-2xl mb-4 font-display" data-id="element-282">
            💛 EL DUELO DEL DIAGNÓSTICO™
          </p>
          <p className="text-sm mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-283">
            La guía de acompañamiento emocional N°1 para personas y familias
            post-diagnóstico en Argentina. Porque atravesar un diagnóstico no
            debería hacerse completamente solo/a.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-12 mb-12 text-sm" data-id="element-284">
            <a href="mailto:contacto@elduelodeldiagnostico.com.ar" className="hover:text-white transition-colors flex items-center justify-center gap-2" data-id="element-285">
              <MessageSquare size={16} data-id="element-286" /> contacto@elduelodeldiagnostico.com.ar
            </a>
            <a href="#" className="hover:text-white transition-colors flex items-center justify-center gap-2" data-id="element-287">
              <Star size={16} data-id="element-288" /> @elduelodeldiagnostico
            </a>
            <a href="#" className="hover:text-white transition-colors flex items-center justify-center gap-2" data-id="element-289">
              <Zap size={16} data-id="element-290" /> elduelodeldiagnostico.com.ar
            </a>
          </div>
          <div className="w-full h-px bg-white/5 mb-8" data-id="element-291"></div>
          <p className="text-xs mb-4" data-id="element-292">
            © El Duelo del Diagnóstico™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-xs italic" data-id="element-293">"No estás solo/a en esto." 💛</p>
        </div>
      </footer>
    </div>;
}